<script>
  // lib
  // import { onDestroy } from "svelte";
  import { fade, slide, scale } from "svelte/transition";
  import { flip } from "svelte/animate";

  // store
  import PollStote from "../stores/PollStore";

  // components
  import PollDetails from "./PollDetails.svelte";

  // export let polls = [];

  // const unsubscribe = PollStote.subscribe((data) => {
  //   polls = data;
  // });

  // onDestroy(() => {
  //   // unsubscribe from store
  //   console.log("component destroyed");
  //   unsubscribe();
  // });
</script>

<div class="poll-list">
  {#each $PollStote as poll (poll.id)}
    <div in:fade out:scale|local animate:flip={{ duration: 500 }}>
      <PollDetails {poll} />
    </div>
  {/each}
</div>

<style>
  .poll-list {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 20px;
  }
  @media (min-width: 768px) {
    .poll-list {
      grid-template-columns: 1fr 1fr;
    }
  }
</style>
